import { observer } from "mobx-react";
import { useCallback, useEffect, useRef, useState } from "react";
import { debounce } from "@mui/material";
import * as rootStore from "stores/root_store";
import { useForm } from "react-hook-form";
import { PAGE_SIZE_DEFAULT } from "utils/constants";
import "./QaPStyle.css";
import { AiOutlineDownload } from "react-icons/ai";
import { ListDate, ListStatusProduct } from "services/commonDate_services";
import {
  Button,
  Checkbox,
  DatePicker,
  Form,
  FormInstance,
  Radio,
  RadioChangeEvent,
  Select,
} from "antd";
import { ActionType, ProColumns } from "@ant-design/pro-components";
import { formatNumber } from "utils/formatHelper";
import CustomProTable from "base/ui/components/CustomTable";
import moment from "moment";
import { BC04Model, Department, ListKeynValue } from "services/report_services";
import "./QaPStyle.css";
import CustomSelect from "base/ui/components/CustomSelect";
import SaveReportForm from "../reportComponents/reportForm";
import TemplateReportModal from "base/ui/components/Modal/TemplateReportModal";
import SearchCollapse from "../reportComponents/searchCollapse";
import Wrapper from "base/ui/components/Wrapper";
import { useResizableColumns } from "utils/reportHelper";
import dayjs from "dayjs";
import { cloneDeep } from "lodash";

// khi toi viet doan code nay, toi cung ko hieu lam, mong ban thong cam
// Array.isArray(registerables) && Chart.register(...registerables);

const listEmployeesStatus = [
  {
    label: "Tất cả",
    value: "null",
  },
  {
    label: "Còn làm việc",
    value: "true",
  },
  {
    label: "Đã nghỉ việc",
    value: "false",
  },
];

export function createQnP() {
  return observer(() => {
    const [form] = Form.useForm();
    //========================================== Khai báo state
    const [dataSearch, setDataSearch] = useState({
      paging: {
        pageSize: PAGE_SIZE_DEFAULT,
        pageIndex: 1,
        orderBy: "",
        orderByDesc: "",
      },
      toSanXuat: [] as string[],
      nhanVien: undefined as string[] | undefined,
      trangThaiNV: null as boolean | null,
      tuNgay: undefined as string | undefined,
      denNgay: undefined as string | undefined,
      // TH : Tổng hợp , CT : chi tiết
      isHasRecord: true,
      type: "TH",
    });
    // lấy data api
    const [dataTable, setDataTable] = useState<BC04Model[]>([]);

    // list department
    const [listDepart, setListDepart] = useState<Department[]>([]);
    // Danh sách nhân viên
    const [listEmployee, setListEmployee] = useState<ListStatusProduct[]>([]);

    //loading page when reload
    const [isLoading, setIsLoading] = useState(true);

    // lay danh sach date tu API
    const [commonDate, setCommonDate] = useState<ListDate[]>([]);
    //lay picked date
    const [pickedDate, setpickedDate] = useState<string>("Today");
    // Kiểm tra call xong  api lấy ngày picked date
    const [isReady, setIsReady] = useState(false);
    // Form validation-----------------------------------
    const { register, handleSubmit } = useForm<String>();
    //==========================================hàm handle
    // lấy common date
    const getDateCommon = async () => {
      await rootStore.commonDatePresenter.getListCommonDate(
        rootStore.commonDateStore
      );
      setCommonDate(rootStore.commonDateStore.listDate.data);
    };

    const getDataAPI = async (data = dataSearch) => {
      // setDataTable([]);
      await rootStore.reportPresenter.getDataBC04(rootStore.reportStore, data);
      if (rootStore.reportStore.BC04NewResponse.isSuccess) {
        const data = [...rootStore.reportStore.BC04NewResponse.data];

        const lineSum = data.pop();

        data.forEach((item, index) => {
          Object.assign(item, { key: item.stt + "" });
          if (index === data.length - 1) {
            Object.assign(item, {
              children: [
                {
                  key: item.stt + ".1",
                  ...lineSum,
                },
              ],
            });
          }
        });

        setDataTable(data);
        return data;
      }
      return [];
    };
    // lấy from date , to date theo key
    const getDateByKey = async (key: string, data?: any) => {
      await rootStore.commonDatePresenter.getDataByCommonDate(
        rootStore.commonDateStore,
        key
      );
      if (rootStore.commonDateStore.commonDate) {
        form.setFieldsValue({
          tuNgay:
            rootStore.commonDateStore.commonDate.fromDate !== ""
              ? dayjs(rootStore.commonDateStore.commonDate.fromDate)
              : undefined,
          denNgay:
            rootStore.commonDateStore.commonDate.toDate !== ""
              ? dayjs(rootStore.commonDateStore.commonDate.toDate)
              : undefined,
        });
        setDataSearch({
          ...dataSearch,
          tuNgay:
            rootStore.commonDateStore.commonDate.fromDate !== ""
              ? rootStore.commonDateStore.commonDate.fromDate
              : undefined,
          denNgay:
            rootStore.commonDateStore.commonDate.toDate !== ""
              ? rootStore.commonDateStore.commonDate.toDate
              : undefined,
        });
        return {
          ...dataSearch,
          tuNgay:
            rootStore.commonDateStore.commonDate.fromDate !== ""
              ? rootStore.commonDateStore.commonDate.fromDate
              : undefined,
          denNgay:
            rootStore.commonDateStore.commonDate.toDate !== ""
              ? rootStore.commonDateStore.commonDate.toDate
              : undefined,
        };
      }
    };
    // lấy danh sách tổ
    const getListDepartment = async () => {
      await rootStore.reportPresenter.getListDepartment(rootStore.reportStore);
      if (rootStore.reportStore.DepartmentResponse.isSuccess) {
        setListDepart(rootStore.reportStore.DepartmentResponse.data);
      }
    };

    // lấy danh sách nhân viên
    const getListEmployees = async (
      keyword = "",
      toSX: string[],
      actived?: boolean
    ) => {
      await rootStore.commonDatePresenter.getDropdownSaleEmployee(
        rootStore.commonDateStore,
        keyword,
        toSX,
        actived
      );
      if (rootStore.commonDateStore.listStatusProductResponse.isSuccess) {
        setListEmployee(
          rootStore.commonDateStore.listStatusProductResponse.data
        );
      }
    };

    const debounceEmployees = useCallback(debounce(getListEmployees, 500), []);

    // handle search form
    const onSearch = async () => {
      setIsLoading(true);
      setDataSearch({
        ...dataSearch,
        paging: { ...dataSearch.paging, pageIndex: 1 },
      });
      if (dataSearch.type === "TH") {
        const temp = cloneDeep(columns);
        temp.map((ct) => {
          if (ct.hideInTable === false) {
            ct.hideInTable = true;
            ct.hideInSetting = true;
            return ct;
          }
          return ct;
        });

        setColumn(temp);
      } else {
        const temp = cloneDeep(columns);
        temp.map((ct) => {
          if (ct.hideInTable === false) {
            ct.hideInTable = true;
            ct.hideInSetting = true;
            return ct;
          }
          return ct;
        });
      }
      await getDataAPI();
      setIsLoading(false);
    };

    const handleChangeListTime = async (
      value: any,
      option: ListKeynValue | ListKeynValue[],
      idKey: string
    ) => {
      if (option && !Array.isArray(option)) {
        setpickedDate(option.key);
        await getDateByKey(option.key);
      } else {
        setpickedDate("");
        setDataSearch({ ...dataSearch, tuNgay: undefined, denNgay: undefined });
        form.setFieldsValue({
          tuNgay: undefined,
          denNgay: undefined,
        });
      }
    };

    // event change list LSX in search
    const handleChangeListTSX = (
      value: any,
      option: Department | Department[]
    ) => {
      if (option && Array.isArray(option)) {
        setDataSearch({
          ...dataSearch,
          toSanXuat: option.map((val) => {
            return val.departmentId;
          }),
        });
        getListEmployees(
          "",
          option.map((val) => {
            return val.departmentId;
          })
        );
      } else {
        setDataSearch({
          ...dataSearch,
          toSanXuat: [],
        });
        getListEmployees("", []);
      }
    };

    //========================================== useEffect

    useEffect(() => {
      const fetchData = async () => {
        const dataDate = await getDateByKey(pickedDate);
        await getListDepartment();
        setDataSearch({
          ...dataSearch,
          tuNgay: dataDate?.tuNgay,
          denNgay: dataDate?.denNgay,
          toSanXuat: rootStore.reportStore.DepartmentResponse.data
            .filter(
              (i) =>
                i.departmentName !== "Khác" &&
                i.departmentName !== "Gia công ngoài"
            )
            .map((i) => i.departmentId),
        });
        // lấy ds nhân viên theo tổ
        await getListEmployees(
          "",
          rootStore.reportStore.DepartmentResponse.data
            .filter(
              (i) =>
                i.departmentName !== "Khác" &&
                i.departmentName !== "Gia công ngoài"
            )
            .map((i) => i.departmentId)
        );

        setIsReady(true);
        await getDateCommon();
      };
      fetchData();
    }, []);

    useEffect(() => {
      if (isReady) {
        setDataSearch({
          ...dataSearch,
          toSanXuat: rootStore.reportStore.DepartmentResponse.data
            .filter(
              (i) =>
                i.departmentName !== "Khác" &&
                i.departmentName !== "Gia công ngoài"
            )
            .map((i) => i.departmentId),
        });
      }
    }, [listDepart]);

    //=======================XXX========================XXX=========================XXX========================= //
    const defaultColumn: ProColumns<BC04Model>[] = [
      {
        title: "STT",
        dataIndex: "stt",
        width: 75,
        key: "stt",
        align: "center",
        // className: '!rounded-none !py-1',
        fixed: "left",
        render: (text, record) =>
          text !== undefined && text !== "-" ? text : "",
        onCell: (record) => {
          return {
            style: {
              textAlign: record.stt ? "center" : "right",
              backgroundColor: record.stt ? "" : "#d9e1f2",
              position: record.stt ? "sticky" : "unset",
              fontWeight: record.stt ? "inherit" : "bold",
              bottom: 0,
              borderRight: !record.stt ? "none" : "",
            },
          };
        },
      },
      {
        title: "Ngày",
        dataIndex: "ngay",
        key: "ngay",
        className: "!py-1",
        fixed: "left",
        width: 100,
        hideInSetting: true,
        hideInTable: true,
        render: (text, record) =>
          record.ngay ? moment(record.ngay).format("DD/MM/YYYY") : "",
        onCell: (record) => {
          return {
            style: {
              textAlign: "center",
              backgroundColor: record.stt ? "" : "#d9e1f2",
              fontWeight: record.stt ? "inherit" : "bold",
              position: !record.stt ? "sticky" : "unset",
              bottom: 0,
              borderRight: !record.stt ? "none" : "",
            },
          };
        },
      },
      {
        title: "Mã NV",
        dataIndex: "maNhanVien",
        key: "maNhanVien",
        className: "!py-1",
        fixed: "left",
        width: 100,
        sorter: true,

        render: (text, record) =>
          text !== undefined && text !== "-" ? text : "",
        onCell: (record) => {
          return {
            style: {
              textAlign: record.stt ? "left" : "right",
              backgroundColor: record.stt ? "" : "#d9e1f2",
              fontWeight: record.stt ? "inherit" : "bold",
              position: !record.stt ? "sticky" : "unset",
              bottom: 0,
              borderRight: !record.stt ? "none" : "",
            },
          };
        },
      },
      {
        title: "Tên NV",
        dataIndex: "tenNhanVien",
        key: "tenNhanVien",
        className: "!py-1",
        fixed: "left",
        width: 200,
        sorter: true,
        render: (text, record) =>
          record.stt ? record.tenNhanVien : "Tổng cộng",
        onCell: (record) => {
          return {
            style: {
              textAlign: record.stt ? "left" : "right",
              backgroundColor: record.stt ? "" : "#d9e1f2",
              fontWeight: record.stt ? "inherit" : "bold",
              position: !record.stt ? "sticky" : "unset",
              bottom: 0,
              borderRight: !record.stt ? "none" : "",
            },
          };
        },
      },
      {
        title: "Số ngày làm việc thực tế (Ngày)",
        dataIndex: "soNgayLamViec",
        key: "soNgayLamViec",
        width: 100,
        className: "!py-1",
        onCell: (record) => {
          return {
            style: {
              textAlign: "right",
              backgroundColor: record.stt ? "" : "#d9e1f2",
              fontWeight: record.stt ? "inherit" : "bold",
              position: !record.stt ? "sticky" : "unset",
              bottom: 0,
              borderRight: !record.stt ? "none" : "",
            },
          };
        },
      },
      {
        title: "TG định mức",
        dataIndex: "tgDinhMuc",
        key: "tgDinhMuc",
        width: 100,
        className: "!py-1",
        render: (text, record) => formatNumber(Number(text), 0),
        onCell: (record) => {
          return {
            style: {
              textAlign: "right",
              backgroundColor: record.stt ? "" : "#d9e1f2",
              fontWeight: record.stt ? "inherit" : "bold",
              position: !record.stt ? "sticky" : "unset",
              bottom: 0,
              borderRight: !record.stt ? "none" : "",
            },
          };
        },
      },
      {
        title: "SL chi tiết hoàn thành",
        dataIndex: "slChiTietHT",
        key: "slChiTietHT",
        width: 100,
        className: "!py-1",
        render: (text, record) => formatNumber(Number(text), 1),
        onCell: (record) => {
          return {
            style: {
              textAlign: "right",
              backgroundColor: record.stt ? "" : "#d9e1f2",
              fontWeight: record.stt ? "inherit" : "bold",
              position: !record.stt ? "sticky" : "unset",
              bottom: 0,
              borderRight: !record.stt ? "none" : "",
            },
          };
        },
      },
      {
        title: "TG thực tế được ghi nhận trong giờ",
        width: 200,
        key: "tgGhiNhanThucTeTrongGio",
        className: "!py-1",
        children: [
          {
            title: "Giờ",
            dataIndex: "soGioTrongGio",
            width: 100,
            key: "soGioTrongGio",
            className: "!py-1",
            render: (text, record) => formatNumber(Number(text), 0),
            onCell: (record) => {
              return {
                style: {
                  textAlign: "right",
                  backgroundColor: record.stt ? "" : "#d9e1f2",
                  fontWeight: record.stt ? "inherit" : "bold",
                  position: !record.stt ? "sticky" : "unset",
                  bottom: 0,
                  borderRight: !record.stt ? "none" : "",
                },
              };
            },
          },
          {
            title: "Phút",
            dataIndex: "soPhutTrongGio",
            width: 100,
            key: "soPhutTrongGio",
            className: "!py-1",
            render: (text, record) => formatNumber(Number(text), 0),
            onCell: (record) => {
              return {
                style: {
                  textAlign: "right",
                  backgroundColor: record.stt ? "" : "#d9e1f2",
                  fontWeight: record.stt ? "inherit" : "bold",
                  position: !record.stt ? "sticky" : "unset",
                  bottom: 0,
                  borderRight: !record.stt ? "none" : "",
                },
              };
            },
          },
        ],
      },
      {
        title: "TG thực tế được ghi nhận ngoài giờ",
        width: 200,
        key: "tgGhiNhanThucTeNgoaiGio",
        className: "!py-1",
        children: [
          {
            title: "Giờ",
            dataIndex: "soGioNgoaiGio",
            width: 100,
            key: "soGioNgoaiGio",
            className: "!py-1",
            render: (text, record) => formatNumber(Number(text), 0),
            onCell: (record) => {
              return {
                style: {
                  textAlign: "right",
                  backgroundColor: record.stt ? "" : "#d9e1f2",
                  fontWeight: record.stt ? "inherit" : "bold",
                  position: !record.stt ? "sticky" : "unset",
                  bottom: 0,
                  borderRight: !record.stt ? "none" : "",
                },
              };
            },
          },
          {
            title: "Phút",
            dataIndex: "soPhutNgoaiGio",
            width: 100,
            key: "soPhutNgoaiGio",
            className: "!py-1",
            render: (text, record) => formatNumber(Number(text), 0),
            onCell: (record) => {
              return {
                style: {
                  textAlign: "right",
                  backgroundColor: record.stt ? "" : "#d9e1f2",
                  fontWeight: record.stt ? "inherit" : "bold",
                  position: !record.stt ? "sticky" : "unset",
                  bottom: 0,
                  borderRight: !record.stt ? "none" : "",
                },
              };
            },
          },
        ],
      },
      {
        title: "TG không tham gia sản xuất",
        key: "tgKhongThamGiaSX",
        className: "!py-1",
        children: [
          {
            title: "Giờ",
            dataIndex: "soGioTGKhongTGSX",
            width: 100,
            key: "soGioTGKhongTGSX",
            className: "!py-1",
            render: (text, record) => formatNumber(Number(text), 0),
            onCell: (record) => {
              return {
                style: {
                  textAlign: "right",
                  backgroundColor: record.stt ? "" : "#d9e1f2",
                  fontWeight: record.stt ? "inherit" : "bold",
                  position: !record.stt ? "sticky" : "unset",
                  bottom: 0,
                  borderRight: !record.stt ? "none" : "",
                },
              };
            },
          },
          {
            title: "Phút",
            dataIndex: "soPhutTGKhongTGSX",
            width: 100,
            key: "soPhutTGKhongTGSX",
            className: "!py-1",
            render: (text, record) => formatNumber(Number(text), 0),
            onCell: (record) => {
              return {
                style: {
                  textAlign: "right",
                  backgroundColor: record.stt ? "" : "#d9e1f2",
                  fontWeight: record.stt ? "inherit" : "bold",
                  position: !record.stt ? "sticky" : "unset",
                  bottom: 0,
                  borderRight: !record.stt ? "none" : "",
                },
              };
            },
          },
        ],
      },
      {
        title: "% TG thực tế/kế hoạch",
        dataIndex: "phanTramTGTTTrenKH",
        key: "phanTramTGTTTrenKH",
        width: 100,
        className: "!py-1",
        render: (text, record) => formatNumber(Number(text), 2),
        onCell: (record) => {
          return {
            style: {
              textAlign: "right",
              backgroundColor: record.stt ? "" : "#d9e1f2",
              fontWeight: record.stt ? "inherit" : "bold",
              position: !record.stt ? "sticky" : "unset",
              bottom: 0,
              borderRight: !record.stt ? "none" : "",
            },
          };
        },
      },
      {
        title: "TG sản xuất 1 chi tiết",
        key: "tgSX1ChiTiet",
        className: "!py-1",
        children: [
          {
            title: "Phút",
            dataIndex: "soPhutTGSX1ChiTiet",
            width: 100,
            key: "soPhutTGSX1ChiTiet",
            className: "!py-1",
            render: (text, record) =>
              record.stt ? formatNumber(Number(text), 0) : "",
            onCell: (record) => {
              return {
                style: {
                  textAlign: "right",
                  backgroundColor: record.stt ? "" : "#d9e1f2",
                  fontWeight: record.stt ? "inherit" : "bold",
                  position: !record.stt ? "sticky" : "unset",
                  bottom: 0,
                  borderRight: !record.stt ? "none" : "",
                },
              };
            },
          },
          {
            title: "Giây",
            dataIndex: "soGiayTGSX1ChiTiet",
            width: 100,
            key: "soGiayTGSX1ChiTiet",
            className: "!py-1",
            render: (text, record) => (record.stt ? text : ""),
            onCell: (record) => {
              return {
                style: {
                  textAlign: "right",
                  backgroundColor: record.stt ? "" : "#d9e1f2",
                  fontWeight: record.stt ? "inherit" : "bold",
                  position: !record.stt ? "sticky" : "unset",
                  bottom: 0,
                  borderRight: !record.stt ? "none" : "",
                },
              };
            },
          },
        ],
      },
    ];
    const [columns, setColumn] = useState<ProColumns<BC04Model>[]>(
      defaultColumn.filter((column) => column.key !== "ngay")
    );

    //========================================================================================================== //
    //-------------------------------------------MẪU BÁO CÁO-------------------------------------------------//
    //========================================================================================================== //

    const tableRef = useRef<ActionType>();

    const constDataName = "bc-04";

    const {
      isResizablePresent,
      resizableColumnSelect,
      columnsState,
      handleColumnsStateChange,
      templateReportModalRef,
      userReports,
      selectedReportId,
      handleResize,
      templateReportModalProps,
    } = useResizableColumns<BC04Model>(columns, setColumn, constDataName);
    //=======================XXX========================XXX=========================XXX========================= //

    return (
      <div className="w-full py-3 px-2">
        {/* 
          // Bắt buộc chọn thời gian
          // mặc định là hôm nay
          // Tổng hợp bỏ cột ngày */}

        {/* Form nhập tìm kiếm */}
        <SearchCollapse title="BC04. Báo cáo sản lượng & năng suất theo công nhân">
          <Form
            form={form}
            onFinish={handleSubmit(onSearch)}
            className={`w-full px-8 py-2 lg:grid lg:grid-cols-2 flex flex-col gap-y-2`}
          >
            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3 col-start-1">
              <div className="min-w-[150px] font-bold text-default text-black sm:text-end">
                <label className=" cursor-pointer">Xem dữ liệu theo</label>
              </div>
              <div className="col-span-2 sm:ml-5 text-default flex gap-x-4 gap-y-2 flex-wrap">
                <Radio.Group
                  onChange={(e: RadioChangeEvent) => {
                    setDataSearch({
                      ...dataSearch,
                      isHasRecord: e.target.value,
                    });
                  }}
                  value={dataSearch.isHasRecord}
                >
                  <Radio className="!text-default" value={true}>
                    Xem nhân viên có ghi nhân
                  </Radio>
                  <Radio className="!text-default" value={false}>
                    Tất cả
                  </Radio>
                </Radio.Group>
              </div>
            </div>

            {/* Chọn tổ */}
            <div className="w-full sm:items-center grid grid-cols-3 col-start-1">
              <CustomSelect
                mode="multiple"
                title="Chọn tổ"
                data={listDepart}
                fieldNames={{ label: "departmentName", value: "departmentId" }}
                filterOption={(input, option) =>
                  (option?.departmentName ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onChangeValue={handleChangeListTSX}
                idKey="toSanXuat"
                value={dataSearch.toSanXuat}
                showSearch
                allowClear
                placeholder="Chọn tổ sản xuất"
              />
            </div>
            {/* Trạng thái nhân viên */}
            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3">
              <label className="min-w-[150px] font-bold text-default text-black sm:text-end">
                Trạng thái nhân viên
              </label>
              <Select
                value={`${dataSearch.trangThaiNV}`}
                placeholder="Chọn trạng thái nhân viên"
                style={{ maxWidth: "100%" }}
                onChange={async (value, option) => {
                  if (option && !Array.isArray(option)) {
                    setDataSearch({
                      ...dataSearch,
                      trangThaiNV: JSON.parse(option.value),
                    });
                    await getListEmployees(
                      undefined,
                      dataSearch.toSanXuat,
                      JSON.parse(option.value)
                    );
                  }
                }}
                className="col-span-2 text-black !text-default [&_span]:!text-default hover:ring-0 hover:outline-none hover:border-border_input !rounded-none border-border_input sm:!ml-5 focus-visible:outline-none"
                options={listEmployeesStatus}
              />
            </div>
            {/* Chọn nhân viên */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                title="Nhân viên"
                mode="multiple"
                data={listEmployee}
                onChangeValue={(value, option) => {
                  // if (option && !Array.isArray(option)) {
                  //   setDataSearch({ ...dataSearch, nhanVien: option.key });
                  // } else {
                  //   setDataSearch({ ...dataSearch, nhanVien: '' });
                  // }
                  if (option && Array.isArray(option)) {
                    setDataSearch({
                      ...dataSearch,
                      nhanVien: option.map((val) => {
                        return val.key;
                      }),
                    });
                  } else {
                    setDataSearch({
                      ...dataSearch,
                      nhanVien: undefined,
                    });
                  }
                }}
                idKey="nhanvien"
                showSearch
                allowClear
                placeholder="Chọn nhân viên"
                onClear={async () =>
                  await getListEmployees("", dataSearch.toSanXuat)
                }
                onSearch={async (value) =>
                  await debounceEmployees(value, dataSearch.toSanXuat)
                }
              />
            </div>

            {/* Chọn thoi gian */}
            <div className="w-full sm:items-center grid grid-cols-3 col-start-1">
              <CustomSelect
                title="Thời gian"
                data={commonDate}
                value={commonDate.find((date) => date.key === pickedDate)}
                onChangeValue={handleChangeListTime}
                idKey="pickedDate"
                showSearch
                allowClear
                placeholder="Chọn khoảng thời gian"
              />
            </div>

            {/* từ ngày */}
            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3 col-start-1">
              <div className="min-w-[150px] font-bold text-default text-black sm:text-end">
                <label htmlFor="tuNgay" className=" cursor-pointer">
                  Từ ngày
                </label>
              </div>
              <Form.Item
                name="tuNgay"
                className="col-span-2 sm:!ml-5 !mb-0"
                rules={[
                  {
                    required: dataSearch.type === "CT",
                    message: "Hãy nhập thông tin cho trường này!",
                  },
                ]}
              >
                <DatePicker
                  id="tuNgay"
                  className="w-full"
                  // Trigger change when blur. e.g. datetime picker no need click confirm button
                  changeOnBlur
                  disabled={pickedDate !== "Custom" && pickedDate !== ""}
                  value={
                    dataSearch.tuNgay ? dayjs(dataSearch.tuNgay) : undefined
                  }
                  format={"DD/MM/YYYY"}
                  placeholder="dd/mm/yyyy"
                  onChange={(date, dateString) => {
                    const pickDate =
                      dateString !== ""
                        ? dayjs(date).format("YYYY-MM-DD")
                        : undefined;
                    setDataSearch({ ...dataSearch, tuNgay: pickDate });
                  }}
                />
              </Form.Item>
            </div>
            {/* đến ngày */}
            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3">
              <div className="min-w-[150px] font-bold text-default text-black sm:text-end">
                <label htmlFor="denNgay" className=" cursor-pointer">
                  Đến ngày
                </label>
              </div>
              <Form.Item
                name="denNgay"
                className="col-span-2 sm:!ml-5 !mb-0"
                rules={[
                  {
                    required: dataSearch.type === "CT",
                    message: "Hãy nhập thông tin cho trường này!",
                  },
                ]}
              >
                <DatePicker
                  id="denNgay"
                  className="w-full"
                  // Trigger change when blur. e.g. datetime picker no need click confirm button
                  changeOnBlur
                  disabled={pickedDate !== "Custom" && pickedDate !== ""}
                  value={
                    dataSearch.denNgay ? dayjs(dataSearch.denNgay) : undefined
                  }
                  format={"DD/MM/YYYY"}
                  placeholder="dd/mm/yyyy"
                  onChange={(date, dateString) => {
                    const pickDate =
                      dateString !== ""
                        ? dayjs(date).format("YYYY-MM-DD")
                        : undefined;
                    setDataSearch({ ...dataSearch, denNgay: pickDate });
                  }}
                />
              </Form.Item>
            </div>

            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3">
              <label className="min-w-[150px] font-bold text-default text-black sm:text-end">
                Loại báo cáo
              </label>
              <div className="col-span-2 sm:ml-5 text-default flex gap-x-4 gap-y-2 flex-wrap">
                <Radio.Group
                  onChange={(e: RadioChangeEvent) => {
                    setDataSearch({
                      ...dataSearch,
                      type: e.target.value,
                    });
                  }}
                  value={dataSearch.type}
                >
                  <Radio className="!text-default" value={"TH"}>
                    Tổng hợp
                  </Radio>
                  <Radio className="!text-default" value={"CT"}>
                    Chi tiết theo ngày
                  </Radio>
                </Radio.Group>
              </div>
            </div>

            {/* button tìm kiếm */}
            <div className="w-full flex justify-center col-span-2">
              <Button
                type="primary"
                loading={isLoading}
                htmlType="submit"
                className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
              >
                Chạy báo cáo
              </Button>
            </div>
          </Form>
        </SearchCollapse>

        <Wrapper>
          {isReady ? (
            <CustomProTable<BC04Model>
              columns={columns}
              handleResize={handleResize}
              isResizablePresent={isResizablePresent}
              resizableColumnSelect={resizableColumnSelect}
              request={async (params = {}, sort, filter) => {
                setIsLoading(true);

                const data = await getDataAPI({
                  ...dataSearch,
                  paging: {
                    ...dataSearch.paging,
                    orderBy:
                      Object.values(sort)[0] === "ascend"
                        ? `${Object.keys(sort)[0].split(",").pop()}`
                        : "",
                    orderByDesc:
                      Object.values(sort)[0] === "descend"
                        ? `${Object.keys(sort)[0].split(",").pop()}`
                        : "",
                  },
                });
                if (Object.values(sort).length) {
                  setDataSearch({
                    ...dataSearch,
                    paging: {
                      ...dataSearch.paging,
                      orderBy:
                        Object.values(sort)[0] === "ascend"
                          ? `${Object.keys(sort)[0].split(",").pop()}`
                          : "",
                      orderByDesc:
                        Object.values(sort)[0] === "descend"
                          ? `${Object.keys(sort)[0].split(",").pop()}`
                          : "",
                    },
                  });
                }
                setIsLoading(false);
                return {
                  data: data,
                  success: rootStore.reportStore.BC04NewResponse.isSuccess,
                };
              }}
              rowKey={"key"}
              dataSource={dataTable.map((data) => data)}
              actionRef={tableRef} // Gán biến tham chiếu cho instance của bảng
              columnsState={{
                value:
                  Object.keys(columnsState).length > 0
                    ? columnsState
                    : undefined,
                onChange: (newColumnsState) => {
                  handleColumnsStateChange(newColumnsState);
                },
              }}
              pagination={{
                pageSize: dataSearch.paging.pageSize,
                total: rootStore.reportStore.BC04NewResponse.paging?.totalCount,
                current: dataSearch.paging.pageIndex,
                responsive: true,
                pageSizeOptions: [10, 25, 50, 100],
                showSizeChanger: true,
                position: ["topRight", "bottomRight"],
                style: { margin: "10px 0" },
                showTotal: (total, range) =>
                  `Hiển thị ${range[0]}-${range[1]} của ${total} mục`,
                onChange: (page, pageSize) => {
                  setDataSearch({
                    ...dataSearch,
                    paging: {
                      ...dataSearch.paging,
                      pageIndex: page,
                      pageSize: pageSize,
                    },
                  });
                },
              }}
              headerTitle={
                <span className="text-default flex flex-col gap-2">
                  <span>
                    Từ ngày:{" "}
                    {dataSearch.tuNgay &&
                      moment(dataSearch.tuNgay).format("DD/MM/YYYY")}
                  </span>
                  <span>
                    Đến ngày:{" "}
                    {dataSearch.denNgay &&
                      moment(dataSearch.denNgay).format("DD/MM/YYYY")}
                  </span>
                </span>
              }
              expandable={{
                expandedRowKeys: [...dataTable.map((i) => i.stt + "")],
                expandIcon: () => {
                  return <></>;
                },
              }}
              toolBarRender={() => [
                <Button
                  size="middle"
                  loading={isLoading}
                  className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
                  onClick={async () => {
                    setIsLoading(true);
                    await rootStore.reportPresenter.exportExcelBC04({
                      ...dataSearch,
                    });
                    setIsLoading(false);
                  }}
                  type="primary"
                >
                  <AiOutlineDownload className="block text-base" />
                  <span className="block">Export Excel</span>
                </Button>,
                <SaveReportForm
                  templateReportModalRef={templateReportModalRef}
                  userReports={userReports}
                  selectedReportId={selectedReportId}
                />,
              ]}
            />
          ) : (
            <CustomProTable<BC04Model>
              loading
              columns={columns}
              handleResize={handleResize}
            />
          )}
        </Wrapper>
        <TemplateReportModal
          ref={templateReportModalRef}
          {...templateReportModalProps}
        />
      </div>
    );
  });
}
